import React, { useContext } from "react";

import styled from "@emotion/styled";

import { DataContext } from "../../../../../../providers/ElectricityCheckoutDataProvider";

const Consumption = styled.div`
    display: block;
    margin-top: 10px;
    font-size: 24px;
    font-weight: 400;
`;

const Amount = () => {
    const dataContext = useContext(DataContext);
    const { consumption } = dataContext.data;
    const { setConsumption } = dataContext.actions;

    /**
     * When the amount changes.
     *
     * @param {*} event
     */
    const onChangeAmount = (event) => {
        setConsumption(event.target.value);
    };

    return (
        <React.Fragment>
            <Consumption>Bedarf:</Consumption>
            <div className="field">
                <div className="control">
                    <input
                        className="input"
                        type="text"
                        placeholder="Menge"
                        name="consumption"
                        onChange={onChangeAmount}
                        value={consumption}
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

export default Amount;
